const SearchedIcon = ({ color = "#999999" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M11 18C12.9333 18 14.5833 17.3208 15.95 15.9625C17.3167 14.6042 18 12.95 18 11C18 9.06667 17.3167 7.41667 15.95 6.05C14.5833 4.68333 12.9333 4 11 4C9.05 4 7.39583 4.68333 6.0375 6.05C4.67917 7.41667 4 9.06667 4 11C4 12.95 4.67917 14.6042 6.0375 15.9625C7.39583 17.3208 9.05 18 11 18ZM11 20C9.75 20 8.57917 19.7625 7.4875 19.2875C6.39583 18.8125 5.44583 18.1708 4.6375 17.3625C3.82917 16.5542 3.1875 15.6042 2.7125 14.5125C2.2375 13.4208 2 12.25 2 11C2 9.76667 2.2375 8.60417 2.7125 7.5125C3.1875 6.42083 3.82917 5.46667 4.6375 4.65C5.44583 3.83333 6.39583 3.1875 7.4875 2.7125C8.57917 2.2375 9.75 2 11 2C12.2333 2 13.3958 2.2375 14.4875 2.7125C15.5792 3.1875 16.5333 3.83333 17.35 4.65C18.1667 5.46667 18.8125 6.42083 19.2875 7.5125C19.7625 8.60417 20 9.76667 20 11C20 12.0667 19.825 13.075 19.475 14.025C19.125 14.975 18.6417 15.8417 18.025 16.625L22 20.6L20.575 22L16.6 18.05C15.8167 18.6667 14.95 19.1458 14 19.4875C13.05 19.8292 12.05 20 11 20Z"
        fill={color}
      />
      <rect x="11" y="7" width="3" height="8" rx="1" fill={color} />
      <rect x="7" y="9" width="3" height="6" rx="1" fill={color} />
    </svg>
  );
};

export default SearchedIcon;
